import * as React from 'react';
import { IconDomRf } from './domRf';
import { IconCianJournal } from './cianJournal';
import { IconFsk } from './fsk';

type TIcons = { [key: string]: React.ReactElement };
export const ICONS: TIcons = {
  fsk: <IconFsk />,
  domRf: <IconDomRf />,
  cianJournal: <IconCianJournal />,
};
